import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Spinner } from 'office-ui-fabric-react/lib/components/Spinner';
import Dialog, { DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { initializeIcons } from 'office-ui-fabric-react/lib/Icons';
import { Separator } from 'office-ui-fabric-react/lib/Separator';
import { mergeStyles } from 'office-ui-fabric-react/lib/Styling';
import * as React from 'react';
import { Label } from 'reactstrap';
import { IAgentChargesWithLog } from '../../../models/IAgentChargesWithLog';
import { IModalDialog } from '../../../models/IModalDialog';
import ConnectionContext from '../../../utils/ConnectionContext';
import { IAgentChargesUpdatePreviewProps } from './IAgentChargesUpdatePreviewProps';
import { IAgentChargesUpdatePreviewState } from './IAgentChargesUpdatePreviewState';
initializeIcons();

const topPanel = mergeStyles({
    textAlign: 'center',
    display: 'block',
    background: '#ffffff',
    boxShadow: '0px 0px 5px 5px #C9C9C9',
    minHeight: '10px',
    marginTop: '5px',
    marginBottom: '5px',
    padding: '10px',
    fontSize: "12px",
    color: '#005269',
    minWidth: '200px',
    top: "0",
    maxWidth: "100%"
});
const topMsgPanel = mergeStyles({
    textAlign: 'center',
    display: 'block',
    background: '#ffffff',
    boxShadow: '0px 0px 1px 1px #C9C9C9',
    borderRadius: "5px",
    minHeight: '10px',
    marginTop: '5px',
    marginBottom: '5px',
    padding: '10px',
    fontSize: "12px",
    color: '#005269',
    minWidth: '200px',
    top: "0",
    maxWidth: "100%"
});
const alertMsgPanel = mergeStyles({
    color: "#E9512D", fontSize: "13px", textAlign: "left"
});
const responsiveMain = mergeStyles({
    margin: "0px auto",
    overflowX: "auto"
});
const responsiveTableContent = mergeStyles({
    display: "table",
    margin: '0 auto',
    width: "100%"
});
const responsiveTable = mergeStyles({
    display: "table",
    margin: '0 auto',
    width: "100%",
    border: "1px solid #005269"
});
const responsiveTableRow = mergeStyles({
    display: "table-row",
    border: "1px solid #005269"
});
const responsiveTableHeaderRow = mergeStyles({
    display: "table-row",
    border: "1px solid #F39000",
    backgroundColor: '#F39000', color: "#ffffff"

});
const responsiveTableBody = mergeStyles({
    display: "table-row-group"
});
const responsiveTableBodyCell = mergeStyles({
    display: "table-cell",
    padding: "5px",
    textAlign: "left",
    verticalAlign: "middle"
});
const responsiveTableBodyCellParticulars = mergeStyles({
    display: "table-cell",
    padding: "5px",
    textAlign: "left",
    verticalAlign: "middle",
    width: "40%"
});
const responsiveTableBodyCellCenter = mergeStyles({
    display: "table-cell",
    padding: "5px",
    textAlign: "center",
    verticalAlign: "middle"
});
const responsiveTableBodyCellRight = mergeStyles({
    display: "table-cell",
    padding: "5px",
    verticalAlign: "middle",
    textAlign: "right"
});
const responsiveTableHeaderCell = mergeStyles({
    textAlign: "center", backgroundColor: "#35AFD1", color: "#FFFFFF", width: "100%", padding: "5px"
});
const submitButton = mergeStyles({ backgroundColor: '#005269', marginRight: "5px" });
const cancelButton = mergeStyles({ backgroundColor: '#E9512D', marginRight: "5px" });
const modifiedBox = mergeStyles({
    textAlign: "right", verticalAlign: "middle", backgroundColor: "#E5CFCB", padding: "5px"
});
const nonModifiedBox = mergeStyles({
    textAlign: "right", verticalAlign: "middle", padding: "5px"
});
const tableValue = mergeStyles({
    textAlign: "right", verticalAlign: "middle", padding: "5px"
});
export interface IDetailsListGroupedItem {
    key: number;
    particulars: string;
    officialfee: number;
    professionalfee: number;
    otherexpenses: number;
    total: number;
    notapplicable: boolean;
}
export const AgentChargesGeneral = ({ agentCharges }) => {
    return (
        <div className={responsiveMain}>
            <div className={responsiveTable}>
                <div className={responsiveTableBody}>
                    <div className={responsiveTableHeaderRow}>
                        <div className={responsiveTableBodyCell}><p><strong>Type of Service </strong></p></div>
                        <div className={responsiveTableBodyCellCenter}><strong>Official fee (€)</strong>
                            <div className={responsiveTableContent}>
                                <div className={responsiveTableBody}>
                                    <div className={responsiveTableHeaderRow}>
                                        <div className={responsiveTableBodyCellCenter}>
                                            Previous
                                        </div>
                                        <div className={responsiveTableBodyCellCenter}>
                                            New
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={responsiveTableBodyCellCenter}><strong>Professional fee (€)</strong>
                            <div className={responsiveTableContent}>
                                <div className={responsiveTableBody}>
                                    <div className={responsiveTableHeaderRow}>
                                        <div className={responsiveTableBodyCellCenter}>
                                            Previous
                                        </div>
                                        <div className={responsiveTableBodyCellCenter}>
                                            New
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={responsiveTableBodyCellCenter}><strong>Other fee (€)</strong>
                            <div className={responsiveTableContent}>
                                <div className={responsiveTableBody}>
                                    <div className={responsiveTableHeaderRow}>
                                        <div className={responsiveTableBodyCellCenter}>
                                            Previous
                                        </div>
                                        <div className={responsiveTableBodyCellCenter}>
                                            New
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={responsiveTableBodyCellCenter}><strong>Total (€)</strong>
                            <div className={responsiveTableContent}>
                                <div className={responsiveTableBody}>
                                    <div className={responsiveTableHeaderRow}>
                                        <div className={responsiveTableBodyCellCenter}>
                                            Previous
                                        </div>
                                        <div className={responsiveTableBodyCellCenter}>
                                            New
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={responsiveTableBodyCellCenter}><strong>N.A</strong>
                            <div className={responsiveTableContent}>
                                <div className={responsiveTableBody}>
                                    <div className={responsiveTableHeaderRow}>
                                        <div className={responsiveTableBodyCellCenter}>
                                            Previous
                                        </div>
                                        <div className={responsiveTableBodyCellCenter}>
                                            New
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        agentCharges.map((tech, i) => {
                            return (
                                <div className={responsiveTableRow}>
                                    <div className={responsiveTableBodyCellParticulars}>{tech.particulars}</div>
                                    <div className={responsiveTableBodyCellRight}>
                                        <div className={responsiveTableContent}>
                                            <div className={responsiveTableBody}>
                                                <div className={responsiveTableRow}>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <div className={tableValue}>{tech.officialfeeOld}</div>
                                                    </div>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <div className={tech.officialfeeOld !== tech.officialfee ? modifiedBox : nonModifiedBox}>{tech.officialfee}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableBodyCellRight}>
                                        <div className={responsiveTableContent}>
                                            <div className={responsiveTableBody}>
                                                <div className={responsiveTableRow}>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <div className={tableValue}>{tech.professionalfeeOld}</div>
                                                    </div>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <div className={tech.professionalfeeOld !== tech.professionalfee ? modifiedBox : nonModifiedBox}>{tech.professionalfee}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableBodyCellRight}>
                                        <div className={responsiveTableContent}>
                                            <div className={responsiveTableBody}>
                                                <div className={responsiveTableRow}>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <div className={tableValue}>{tech.otherexpensesOld}</div>
                                                    </div>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <div className={tech.otherexpensesOld !== tech.otherexpenses ? modifiedBox : nonModifiedBox}>{tech.otherexpenses}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableBodyCellRight}>
                                        <div className={responsiveTableContent}>
                                            <div className={responsiveTableBody}>
                                                <div className={responsiveTableRow}>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <div className={tableValue}>{tech.totalOld}</div>
                                                    </div>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <div className={tech.totalOld !== tech.total ? modifiedBox : nonModifiedBox}>{tech.total}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableBodyCellRight}>
                                        <div className={responsiveTableContent}>
                                            <div className={responsiveTableBody}>
                                                <div className={responsiveTableRow}>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <input type="checkbox" value={tech.particulars} checked={agentCharges[i].notApplicableOld} disabled />
                                                    </div>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <input type="checkbox" value={tech.particulars} checked={agentCharges[i].notApplicable} disabled />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}
export const AgentChargesHourlyRate = ({ agentCharges }) => {
    return (
        <div className={responsiveMain}>
            <div className={responsiveTable}>
                <div className={responsiveTableBody}>
                    <div className={responsiveTableHeaderRow}>
                        <div className={responsiveTableBodyCell}><p><strong>Type of Service </strong></p></div>
                        <div className={responsiveTableBodyCellCenter}><strong>Paralegal level (€)</strong>
                            <div className={responsiveTableContent}>
                                <div className={responsiveTableBody}>
                                    <div className={responsiveTableHeaderRow}>
                                        <div className={responsiveTableBodyCellCenter}>
                                            Previous
                                        </div>
                                        <div className={responsiveTableBodyCellCenter}>
                                            New
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={responsiveTableBodyCellCenter}><strong>Associate level  (€)</strong>
                            <div className={responsiveTableContent}>
                                <div className={responsiveTableBody}>
                                    <div className={responsiveTableHeaderRow}>
                                        <div className={responsiveTableBodyCellCenter}>
                                            Previous
                                        </div>
                                        <div className={responsiveTableBodyCellCenter}>
                                            New
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={responsiveTableBodyCellCenter}><strong>Partner level (€)</strong>
                            <div className={responsiveTableContent}>
                                <div className={responsiveTableBody}>
                                    <div className={responsiveTableHeaderRow}>
                                        <div className={responsiveTableBodyCellCenter}>
                                            Previous
                                        </div>
                                        <div className={responsiveTableBodyCellCenter}>
                                            New
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={responsiveTableBodyCellCenter}><strong>Total (€)</strong>
                            <div className={responsiveTableContent}>
                                <div className={responsiveTableBody}>
                                    <div className={responsiveTableHeaderRow}>
                                        <div className={responsiveTableBodyCellCenter}>
                                            Previous
                                        </div>
                                        <div className={responsiveTableBodyCellCenter}>
                                            New
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={responsiveTableBodyCellCenter}><strong>N.A</strong>
                            <div className={responsiveTableContent}>
                                <div className={responsiveTableBody}>
                                    <div className={responsiveTableHeaderRow}>
                                        <div className={responsiveTableBodyCellCenter}>
                                            Previous
                                        </div>
                                        <div className={responsiveTableBodyCellCenter}>
                                            New
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        agentCharges.map((tech, i) => {
                            return (
                                <div className={responsiveTableRow}>
                                    <div className={responsiveTableBodyCellParticulars}>{tech.particulars}</div>
                                    <div className={responsiveTableBodyCellRight}>
                                        <div className={responsiveTableContent}>
                                            <div className={responsiveTableBody}>
                                                <div className={responsiveTableRow}>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <div className={tableValue}>{tech.officialfeeOld}</div>
                                                    </div>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <div className={tech.officialfeeOld !== tech.officialfee ? modifiedBox : nonModifiedBox}>{tech.officialfee}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableBodyCellRight}>
                                        <div className={responsiveTableContent}>
                                            <div className={responsiveTableBody}>
                                                <div className={responsiveTableRow}>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <div className={tableValue}>{tech.professionalfeeOld}</div>
                                                    </div>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <div className={tech.professionalfeeOld !== tech.professionalfee ? modifiedBox : nonModifiedBox}>{tech.professionalfee}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableBodyCellRight}>
                                        <div className={responsiveTableContent}>
                                            <div className={responsiveTableBody}>
                                                <div className={responsiveTableRow}>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <div className={tableValue}>{tech.otherexpensesOld}</div>
                                                    </div>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <div className={tech.otherexpensesOld !== tech.otherexpenses ? modifiedBox : nonModifiedBox}>{tech.otherexpenses}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableBodyCellRight}>
                                        <div className={responsiveTableContent}>
                                            <div className={responsiveTableBody}>
                                                <div className={responsiveTableRow}>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <div className={tableValue}>{tech.totalOld}</div>
                                                    </div>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <div className={tech.totalOld !== tech.total ? modifiedBox : nonModifiedBox}>{tech.total}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableBodyCellRight}>
                                        <div className={responsiveTableContent}>
                                            <div className={responsiveTableBody}>
                                                <div className={responsiveTableRow}>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <input type="checkbox" value={tech.particulars} checked={agentCharges[i].notApplicableOld} disabled />
                                                    </div>
                                                    <div className={responsiveTableBodyCellRight}>
                                                        <input type="checkbox" value={tech.particulars} checked={agentCharges[i].notApplicable} disabled />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}
export default class AgentChargesUpdatePreview extends React.Component<IAgentChargesUpdatePreviewProps, IAgentChargesUpdatePreviewState>
{
    private connectionContext: ConnectionContext;
    private dialog: IModalDialog;
    private saving: boolean = false;

    constructor(props: IAgentChargesUpdatePreviewProps, state: IAgentChargesUpdatePreviewState) {
        super(props);
        this.connectionContext = this.props.connectionContext;

        this.state = {
            loading: false,
            inputError: 'This field is required',
            showError: false,
            isValidData: true,
            Countries: [],
            hideErrorDialog: true,
            agentCharges: [],
            selectedCountry: this.props.selectedCountry,
            selectedcountries: this.props.selectedcountries,
            hideSuccessDialog: true,
        }
        this.dialog = {
            hideDialog: true,
            accessDeniedDialog: false,
            dialogMessage: '',
            dialogBody: '',
            mode: ''
        }
    }
    public async componentDidMount() {
        if (this.props.agentCharges.length > 0) {
            this.setState((prevState: IAgentChargesUpdatePreviewState): IAgentChargesUpdatePreviewState => {
                prevState.agentCharges = this.props.agentCharges;
                prevState.agentCharges.forEach((item: IAgentChargesWithLog) => {
                    item.notApplicable = (item.total > 0 ? false : true);
                });
                return prevState;
            });
        }
    }
    public render(): React.ReactElement<IAgentChargesUpdatePreviewProps> {
        const trademarkitems = this.state.agentCharges.filter(tech => tech.category === "TRADE MARK");
        const patentsitems = this.state.agentCharges.filter(tech => tech.category === "PATENTS");
        const designitems = this.state.agentCharges.filter(tech => tech.category === "DESIGN");
        const hourlyrateitems = this.state.agentCharges.filter(tech => tech.category === "HOURLY RATE PROSECUTION");

        return (
            <div className={topPanel}>
                {
                    (!this.saving) && (
                        <div className={responsiveTableHeaderCell}>
                            <h6>Preview</h6>
                        </div>)
                }
                {
                    (this.saving) && (
                        <div>
                            <div>
                                <Spinner label="Please wait..." />
                            </div>
                        </div>)
                }
                {
                    <div>
                        <div>
                            <Dialog
                                hidden={this.state.hideErrorDialog}
                                dialogContentProps={{
                                    type: DialogType.largeHeader,
                                    title: this.dialog.dialogMessage,
                                }}
                                maxWidth="1024px"
                                closeButtonAriaLabel="Close"
                            >
                                <div>
                                    <div>
                                        <Label> {this.dialog.dialogBody} </Label>
                                    </div>
                                </div>
                                <DialogFooter>
                                    <DefaultButton onClick={this.closeModelPopUp} className={submitButton} data-automation-id="test" text="Ok" disabled={false} />
                                </DialogFooter>
                            </Dialog>
                        </div>
                    </div>
                }
                {
                    <div>
                        <div>
                            <Dialog
                                hidden={this.state.hideSuccessDialog}
                                dialogContentProps={{
                                    type: DialogType.largeHeader,
                                    title: this.dialog.dialogMessage,
                                }}
                                maxWidth="1024px"
                                closeButtonAriaLabel="Close"
                            >
                                <div>
                                    <div>
                                        <Label> Revised agent fee for <strong> {this.state.selectedCountry} </strong> is successfully submitted. Please select another jurisdiction, if any, from the list and revise the charges.</Label>
                                    </div>
                                </div>
                                <DialogFooter>
                                    <PrimaryButton onClick={this.props.onClose} data-automation-id="test" text="Ok" className={submitButton} iconProps={{ iconName: 'CompletedSolid' }} />
                                </DialogFooter>
                            </Dialog>
                        </div>
                    </div>
                }
                {
                    <div>
                        <div>
                            <div className={topMsgPanel}>You have chosen <strong>{this.state.selectedcountries}</strong> as your service available jurisdiction <br />
                                Now you are viewing charges for : <strong>{this.state.selectedCountry}</strong>
                            </div>
                            <div>
                                <Separator></Separator>
                                <h6>TRADE MARK</h6>
                                <AgentChargesGeneral agentCharges={trademarkitems} />
                            </div>
                            <div>
                                <Separator></Separator>
                                <h6>PATENTS</h6>
                                <AgentChargesGeneral agentCharges={patentsitems} />
                            </div>
                            <div>
                                <Separator></Separator>
                                <h6>DESIGN</h6>
                                <AgentChargesGeneral agentCharges={designitems} />
                            </div>
                            <div>
                                <Separator></Separator>
                                <h6>HOURLY RATE PROSECUTION</h6>
                                <AgentChargesHourlyRate agentCharges={hourlyrateitems} />
                            </div>
                        </div>
                        <div className={alertMsgPanel}>Please make sure you have entered the correct values before submitting. Once submitted, it cannot be modified.
                            In future, if there is any correction in the charges, please contact agent.network@zacco.com.
                        </div>
                        <div>
                            <br />
                            <PrimaryButton text="Submit" data-automation-id="test" onClick={this.submitForm.bind(this)} className={submitButton} iconProps={{ iconName: 'SaveAndClose' }} />
                            <PrimaryButton text="Corrections?" data-automation-id="test" onClick={this.props.onCancel} className={cancelButton} iconProps={{ iconName: 'Edit' }} />
                        </div>
                    </div>
                }
            </div>
        );
    }
    private submitForm = async (): Promise<void> => {
        try {
            this.saving = true;
            await this.connectionContext.put("AgentCharges", this.state.agentCharges);
            this.setState((prevState: IAgentChargesUpdatePreviewState): IAgentChargesUpdatePreviewState => {
                prevState.isValidData = true;
                prevState.hideSuccessDialog = false;
                return prevState;
            });
        } catch (exception) {
            this.handleError("Message", "Unable to process at the moment. Please try again or contact agent.network@zacco.com.");
        }
    }
    private closeModelPopUp = () => {
        this.setState((previousState: IAgentChargesUpdatePreviewState, props: IAgentChargesUpdatePreviewProps): IAgentChargesUpdatePreviewState => {
            previousState.hideErrorDialog = true;
            this.saving = false;
            return previousState;
        });
    }
    private handleError(message: string, body: string) {
        this.dialog.dialogMessage = message;
        this.dialog.dialogBody = body;
        this.dialog.accessDeniedDialog = false;
        this.dialog.hideDialog = false;
        this.setState((previousState: IAgentChargesUpdatePreviewState, props: IAgentChargesUpdatePreviewProps): IAgentChargesUpdatePreviewState => {
            previousState.hideErrorDialog = false;
            return previousState;
        });
    }
}